import styled from '@emotion/styled';

export const Container = styled.div`
    padding: 24px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const SectionTitle = styled.h4`
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #333;
`;

export const SectionDescription = styled.p`
    font-size: 14px;
    color: #666;
    margin-bottom: 24px;
`;

export const Row = styled.div`
    display: flex;
    gap: 20px;
    margin-bottom: 24px;
    flex-wrap: wrap;
    max-width: 800px;

    > * {
        flex: 0 0 auto;
        min-width: 250px;
        max-width: 350px;
    }
`;

export const TableContainer = styled.div`
    margin: 24px 0;
    border: 1px solid #e1e5e9;
    border-radius: 4px;
    overflow: visible;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;

    th {
        background-color: #f8f9fa;
        padding: 12px 16px;
        text-align: left;
        font-weight: 600;
        font-size: 14px;
        color: #495057;
        border-bottom: 1px solid #e1e5e9;
    }

    td {
        padding: 12px 16px;
        border-bottom: 1px solid #e1e5e9;
        vertical-align: middle;

        &.domain-name-email {
            display: flex;
            align-items: center;
            gap: 4px;
        }

        &.action-column {
            width: 60px;
            text-align: center;
            vertical-align: middle;
        }
    }

    tr:last-child td {
        border-bottom: none;
    }
`;

export const DomainInput = styled.input`
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 8px 12px;
    font-size: 14px;
    width: 100%;
    min-width: 120px;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }

    &::placeholder {
        color: #6c757d;
    }
`;

export const WhitelistingSection = styled.div`
    margin: 24px 0;
    padding: 16px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border-left: 4px solid #007bff;
`;

export const WhitelistingInfo = styled.div`
    font-size: 14px;
    color: #495057;
    margin-bottom: 12px;
`;

export const SwitchContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const SaveButton = styled.button`
    background-color: #28a745;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    margin-top: 24px;

    &:hover:not(:disabled) {
        background-color: #218838;
    }

    &:disabled {
        background-color: #6c757d;
        cursor: not-allowed;
    }
`;

export const DeleteButton = styled.button`
    background-color: transparent;
    border: 1px solid transparent;
    color: #e07484;
    cursor: pointer;
    font-size: 18px;
    font-weight: bold;
    padding: 4px 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    width: 28px;
    height: 28px;
    line-height: 1;

    &:hover {
        background-color: #e07484;
        color: white;
        border-color: #e07484;
        transform: scale(1.05);
    }

    &:active {
        transform: scale(0.95);
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(224, 116, 132, 0.25);
    }
`;
